import SmoothScroll from '../singleton/SmoothScroll';
import WindowSize from '../singleton/WindowSize';

class GrimaceScale {
  $container: JQuery<HTMLElement>;
  $question!: JQuery<HTMLElement>;
  $questionsWrap!: JQuery<HTMLElement>;
  $btns!: JQuery<HTMLElement>;
  $scoreBreakdown!: JQuery<HTMLElement>;
  $breakdownItems!: JQuery<HTMLElement>;
  $scoreWrap!: JQuery<HTMLElement>;
  $score!: JQuery<HTMLElement>;
  $resultsOptions!: JQuery<HTMLElement>;
  $progressBar!: JQuery<HTMLElement>;
  $progressBarCurrent!: JQuery<HTMLElement>;
  windowSize: WindowSize;
  scroll: typeof SmoothScroll;

  mobileCurrentStep!: number;

  constructor() {
    this.$container = jQuery('.grimace-scale');
    this.windowSize = WindowSize.getInstance();
    this.scroll = SmoothScroll;

    if (!this.$container.length) return;

    this.$question = this.$container.find('.grimace-scale__question');
    this.$questionsWrap = this.$container.find(
      '.grimace-scale__questions-wrap',
    );
    this.$btns = this.$container.find('.grimace-scale__btn');
    this.$scoreBreakdown = this.$container.find(
      '.grimace-scale__score-breakdown',
    );
    this.$breakdownItems = this.$container.find(
      '.grimace-scale__breakdown-item',
    );

    this.$scoreWrap = this.$container.find('.grimace-scale__score-wrap');
    // find the {score} inside the $scoreWrap and replace it with the <span class="grimace-scale__score">0</span>
    this.$scoreWrap.html(
      this.$scoreWrap
        .html()
        .replace('{score}', '<span class="grimace-scale__score">0</span>'),
    );
    this.$score = this.$container.find('.grimace-scale__score');
    this.$resultsOptions = this.$container.find(
      '.grimace-scale__result-option',
    );
    this.$progressBar = this.$container.find('.progress-bar');
    this.$progressBarCurrent = this.$container.find('.progress-bar__current');
    this.mobileCurrentStep = 0;

    this.init();
  }

  init() {
    this.$question.on('change', (_e) => {
      this.calculateScore();
      this.updateButtons();
      this.mobilePageScrolling();
    });

    this.$btns.on('click', (e) => {
      e.preventDefault();

      const type = jQuery(e.currentTarget).hasClass('grimace-scale__btn--next')
        ? 'next'
        : 'prev';

      this.changeStep(type);
    });
  }

  mobilePageScrolling() {
    // const { width } = this.windowSize.getSize();
    // if (width >= 768) return;

    // scroll to results if last step
    if (this.mobileCurrentStep === this.$question.length - 1) {
      this.scroll.scrollToSection(this.$scoreBreakdown);
    }
  }

  changeStep(type: 'next' | 'prev') {
    if (type === 'next') {
      if (this.mobileCurrentStep < this.$question.length - 1) {
        this.mobileCurrentStep++;
      }
    } else if (type === 'prev') {
      if (this.mobileCurrentStep > 0) {
        this.mobileCurrentStep--;
      }
    }

    // set env var
    this.$questionsWrap.css('--current-question', this.mobileCurrentStep + 1);

    this.updateButtons();
    this.updateProgressBar();
  }

  updateButtons() {
    this.$btns.each((_, el) => {
      const $el = jQuery(el);

      if ($el.hasClass('grimace-scale__btn--next')) {
        // next btn
        // disable if last step
        if (this.mobileCurrentStep >= this.$question.length - 1) {
          $el.attr('disabled', 'true');
          // disable if current question is not answered
        } else if (
          !this.$question.eq(this.mobileCurrentStep).find('input:checked')
            .length
        ) {
          $el.attr('disabled', 'true');
        } else {
          $el.removeAttr('disabled');
        }
      } else {
        // prev btn
        if (this.mobileCurrentStep <= 0) {
          $el.attr('disabled', 'true');
        } else {
          $el.removeAttr('disabled');
        }
      }
    });
  }

  updateProgressBar() {
    this.$progressBarCurrent.text(this.mobileCurrentStep + 1);
    // set css var --current-step
    this.$progressBar.css('--current-step', this.mobileCurrentStep + 1);
  }

  calculateScore() {
    let score = 0;

    // get all checked inputs
    const $checked = this.$question.find('input:checked');

    // calculate score
    $checked.each((_, el) => {
      score += parseInt(jQuery(el).val() as string, 10);

      // update breakdown value
      const questionIndex = jQuery(el).data('question-index');
      const $breakdownItem = this.$breakdownItems.filter(
        `[data-question-index="${questionIndex}"]`,
      );
      $breakdownItem
        .find('.grimace-scale__breakdown-value')
        .text(jQuery(el).val() as string);
    });

    this.$score.text(score);

    this.evaluateResults(score);
  }

  evaluateResults(score: number) {
    // hide all
    this.$resultsOptions.removeClass('is-active');

    // show the correct one
    this.$resultsOptions.each((_, el) => {
      const $el = jQuery(el);
      const maxScore = parseInt($el.data('score'), 10);

      if (score <= maxScore) {
        $el.addClass('is-active');
        return false; // break the loop
      }
    });
  }
}

export default GrimaceScale;
